import { Row, RenderConfig, TextInput, Column, EMPTY_ARRAY } from 'commons-ui';

export const FORM_FIELD_KEYS = {
	ATHENA_QUERY_TEXT: 'athenaQueryText',
	CAMPAIGN_NAME: 'campaignName'
};

export const FORM_FIELD_LABELS = {
	[FORM_FIELD_KEYS.ATHENA_QUERY_TEXT]: 'Athena Query Text',
	[FORM_FIELD_KEYS.CAMPAIGN_NAME]: 'Campaign Name'
};

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.ATHENA_QUERY_TEXT]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.ATHENA_QUERY_TEXT)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.ATHENA_QUERY_TEXT])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } },
			required: true
		}),
	[FORM_FIELD_KEYS.CAMPAIGN_NAME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.CAMPAIGN_NAME)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.CAMPAIGN_NAME])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			overrides: { InputContainer: { style: () => ({ backgroundColor: 'white' }) } },
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.ATHENA_QUERY_TEXT)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.CAMPAIGN_NAME)])])
];
